import { TemplateKey } from "PFApp/constants/templates";
import { useTemplate } from "PFApp/hooks";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentGroupPermissions } from "PFCore/hooks/use_current_group_permissions";
import { AccessLevel, AuditRole, FeatureFlag } from "PFTypes";

type UseCanEditAuditRoles = Pick<AuditRole, "templateId" | "workflowState" | "coowned">;

type UseCanEditAuditRolesReturn = {
  canEditAuditRole: boolean;
};

const EXCEPTION_WORKFLOW_STATES = ["exception"];

export const useCanEditAuditRoles = ({
  coowned,
  templateId,
  workflowState
}: UseCanEditAuditRoles): UseCanEditAuditRolesReturn => {
  const { getActivityPermissions } = useCurrentGroupPermissions();
  const auditRoleTemplate = useTemplate(TemplateKey.AuditRole);
  const isEnabled = useIsFeatureEnabled();

  const isAuditRole = auditRoleTemplate?.id === templateId;
  const auditRolePermissions = getActivityPermissions(auditRoleTemplate);

  const hasEditableWorkflowState = !EXCEPTION_WORKFLOW_STATES.includes(workflowState);

  const canEditAuditRole =
    isEnabled(FeatureFlag.EditableAuditRoles) &&
    isAuditRole &&
    auditRolePermissions === AccessLevel.ReadWrite &&
    coowned &&
    hasEditableWorkflowState;

  return {
    canEditAuditRole
  };
};
